var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import serialize from "form-serialize";
import React from "react";
import StepWizard from "react-step-wizard";
import Swal from "sweetalert2";
import Footer from "./Footer";
import MenuPlanNav from "./MenuPlanNav";
import Step1 from "./Step1";
import Step2 from "./Step2";
import Step3 from "./Step3";
import Step4 from "./Step4";
import Step5 from "./Step5";
import Step6 from "./Step6";
export default class MealSetup extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            meals: [],
            allergens: [],
            proteins: [],
            options: [],
            step: 1,
            sw: null,
            selections: {
                meal: null,
                allergens: [],
                protein: null,
                options: [],
                mode: null
            }
        };
        this.handleChange = (event, name, callback) => {
            const value = event.currentTarget.value;
            const { selections } = this.state;
            //Add or remove checkboxes
            if (name == "allergens" || name == "options") {
                let data = selections[name];
                if (event.currentTarget.checked) {
                    data.push(value);
                }
                else {
                    data = data.filter(a => a != value);
                }
                selections[name] = data;
                this.setState(Object.assign(Object.assign({}, this.state), { selections }));
                return;
            }
            //Simple variable assignments        
            //@ts-ignore: Force the name string into the state selections
            selections[name] = value;
            this.setState(Object.assign(Object.assign({}, this.state), { selections }));
            if (callback)
                callback();
        };
        //Returns true or false depdning on if the current wizard step meets selected criteria
        this.canContinue = () => {
            //Get current step
            switch (this.state.step) {
                case 1:
                    return this.state.selections.meal != null;
                case 2:
                    return true;
                case 3:
                    return this.state.selections.protein != null;
                case 4:
                    return this.state.selections.mode != null;
                case 5:
                    return this.state.selections.mode != null;
                default:
                    return false;
            }
        };
        this.onStepChange = (stats) => {
            this.setState({
                step: stats.activeStep
            });
            const percentage = `${(100 / 5) * (stats.activeStep - 1)}`;
            document.documentElement.style.setProperty("--wizard-progress", percentage);
            //On last slide, submit form data via AJAX.. If this is successful, redirect to edit the plan
            //On last slide, submit form via JS
            if (stats.activeStep == 6) {
                this.submitForm();
            }
        };
        this.submitForm = () => {
            //Simply submit the form via POST
            // setTimeout(function(){
            //     const form = document.getElementById("plans-edit-form") as HTMLFormElement
            //     form.submit()
            // }, 800)
            const form = document.getElementById("plans-edit-form");
            const obj = serialize(form);
            const self = this;
            setTimeout(function () {
                fetch("/ajax/createPlan", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/x-www-form-urlencoded",
                    },
                    body: obj
                })
                    .then()
                    .then(response => response.json())
                    .then((data) => {
                    if (data.error) {
                        Swal.fire({
                            icon: "error",
                            title: "Sorry",
                            html: "We couldn't create a menu plan that exactly fits your requirements. Please try again with different options.",
                            showCancelButton: true,
                            confirmButtonText: "Restart"
                        })
                            .then(result => {
                            window.location.replace("/plans");
                        });
                    }
                    else {
                        //Redirect to edit page
                        window.location.replace("/plans-edit");
                    }
                })
                    .catch((err) => {
                    console.error(err);
                    Swal.fire({
                        icon: "error",
                        title: "Error",
                        html: "An error occured trying to process your request",
                        showCancelButton: true,
                        confirmButtonText: "Retry",
                        cancelButtonText: "Cancel"
                    })
                        .then(result => {
                        if (result.isConfirmed) {
                            self.submitForm();
                        }
                        else {
                            window.location.replace("/");
                        }
                    });
                });
            }, 0);
        };
        this.setInstance = (sw) => {
            this.setState({ sw });
        };
        this.loadData();
    }
    render() {
        const { meals, allergens, proteins, step, options } = this.state;
        //if(!this.state.sw) return null
        return (React.createElement("div", { className: "container-fluid" },
            React.createElement("form", { method: "post", action: "plans-edit", id: "plans-edit-form" },
                React.createElement("div", { className: "plan-steps" },
                    React.createElement(StepWizard, { className: "plan-step", nav: React.createElement(MenuPlanNav, null), instance: this.setInstance, onStepChange: this.onStepChange, transitions: {
                            enterRight: "animate__animated animate__faster animate__fadeInRight",
                            enterLeft: "animate__animated animate__faster animate__fadeInLeft",
                            exitRight: "animate__animated animate__faster animate__fadeOutRight",
                            exitLeft: "animate__animated animate__faster animate__fadeOutLeft",
                            intro: "animate__animated animate__faster animate__fadeIn",
                        } },
                        React.createElement(Step1, { handleChange: this.handleChange, meals: meals }),
                        React.createElement(Step2, { handleChange: this.handleChange, allergens: allergens, selections: this.state.selections.allergens }),
                        React.createElement(Step3, { handleChange: this.handleChange, proteins: proteins }),
                        React.createElement(Step4, { handleChange: this.handleChange }),
                        React.createElement(Step5, { handleChange: this.handleChange, options: options, selected: this.state.selections.options }),
                        React.createElement(Step6, null)),
                    React.createElement(Footer, { sw: this.state.sw, key: step, canContinue: this.canContinue(), visible: step < 6 })))));
    }
    //Load all data
    loadData() {
        return __awaiter(this, void 0, void 0, function* () {
            const [meals, allergens, proteins, options] = yield Promise.all([
                this.loadRemoteData("/ajax/getMealProducts"),
                this.loadRemoteData("/ajax/getAllergenList"),
                this.loadRemoteData("/ajax/getProteinPrefs"),
                this.loadRemoteData("/ajax/getMealOptions")
            ]);
            this.setState({
                meals,
                allergens,
                proteins,
                options,
                isLoading: false
            });
        });
    }
    //Load remote data and updates the states 'stateVar' value
    loadRemoteData(url) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield fetch(url);
            const data = yield response.json();
            return data;
        });
    }
}
